import { fork, takeEvery } from "redux-saga/effects";
import {SET_SETTING_CURRENCY, SET_SETTING_COLOR, SET_SETTING_SIZE, SET_SETTING_GROUP_LEVEL1, SET_SETTING_GROUP_LEVEL2, SET_ETFS, SET_SETTING_TRADE_STATUS} from "../model/redux-actions";

import { initializeSaga } from "./initialize";
import { recalculateSaga } from "./recalculate";

export function* rootSaga() {
	yield fork(initializeSaga);

	yield takeEvery(SET_SETTING_CURRENCY, recalculateSaga);
	yield takeEvery(SET_SETTING_COLOR, recalculateSaga);
	yield takeEvery(SET_SETTING_SIZE, recalculateSaga);
	yield takeEvery(SET_SETTING_GROUP_LEVEL1, recalculateSaga);
	yield takeEvery(SET_SETTING_GROUP_LEVEL2, recalculateSaga);
	yield takeEvery(SET_ETFS, recalculateSaga);
	yield takeEvery(SET_SETTING_TRADE_STATUS, recalculateSaga);
}